import unitView from './unit-view'

export default unitView
